import React from 'react';

import { Badge } from 'apps/auth/components/common/Badge/Badge';
import { DiskBadge } from 'apps/auth/components/common/DiskBadge/DiskBadge';
import { Icon } from 'apps/auth/components/common/Icon/Icon';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { DiskBadgeWrapper, PanelContent, PanelFrame, PanelRightBlock, SelectedDiskBadge } from 'apps/auth/components/common/Panel/styles';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { Text } from 'apps/auth/components/common/Text/Text';
import { usePageMessages } from 'apps/auth/hooks/selectors';
import { getText, GTPaymentMethodService } from 'apps/auth/services/GTPaymentMethodService';

import ActionBanner from './ActionBanner';

const PaymentMethodBonus = (props) => {
    const { gotIt, methodMaxInfo, methodMinInfo, balanceNotEnough } = usePageMessages();
    const fromRestriction = props.commission?.restrictionFrom;
    const bonusBalance = +props.item?.balance;

    const fromAmountIssue = GTPaymentMethodService.getIssueType(
        props.amountFrom,
        fromRestriction?.minAmount,
        fromRestriction?.maxAmount,
        fromRestriction?.multiple,
        bonusBalance.toString(),
    );
    const popupText = getText(
        { name: props.item?.sourceName, amountFrom: props.amountFrom },
        fromAmountIssue,
        fromRestriction,
        methodMaxInfo,
        methodMinInfo,
        balanceNotEnough,
        bonusBalance,
    );

    const getBadge = (badge) => {
        if (badge) {
            return <Badge variant="primary" caption={badge} />;
        }
        return null;
    };
    const popupComponent = (
        <SimplePopup text={popupText} popupRef={props.popupRef}>
            <PopupButton title={gotIt} text={gotIt} iconName="check" onClick={() => props.popupRef.current?.close()} />
        </SimplePopup>
    );

    if (bonusBalance > 0) {
        return (
            <Panel
                onClick={() => {
                    if (fromAmountIssue) {
                        props.popupRef.current?.open(popupComponent);
                    } else if (props.actionBanner && !fromAmountIssue) {
                        props.popupRef.current?.open(
                            <ActionBanner actionBanner={props.actionBanner} popupRef={props.popupRef} handleClick={() => props.onClick(props.item)} />,
                        );
                    } else {
                        props.onClick(props.item);
                    }
                }}
                negativeMargin
                isHoverable
            >
                <PanelFrame>
                    <DiskBadgeWrapper>
                        <DiskBadge variant="secondary" isDisabled={!!fromAmountIssue} iconName="gift" />
                        {props.isSelected && (
                            <SelectedDiskBadge>
                                <DiskBadge variant="selectedPassive" iconName="check" />
                            </SelectedDiskBadge>
                        )}
                    </DiskBadgeWrapper>
                    <PanelContent>
                        <Text color={fromAmountIssue ? 'lightGray' : 'primary'}>{`${props.item?.balance} ${props.item?.currencyCode}`}</Text>
                    </PanelContent>
                    <PanelRightBlock>{fromAmountIssue ? <Icon name="info-rounded" color="lightGray" size="16px" /> : getBadge(props.badge)}</PanelRightBlock>
                </PanelFrame>
            </Panel>
        );
    }

    return null;
};
export default PaymentMethodBonus;
